import React from 'react';
import SmileGallery from './SmileGallery';

export default function BeforeAfterGallery() {
  return <SmileGallery />;
}